import "./style.css";
import { jsx as c } from "react/jsx-runtime";
import { forwardRef as G } from "react";
import { c as m } from "../../__shared__/index.js";
const _ = new RegExp("\\p{Lu}", "gu"), f = new RegExp("-\\p{Ll}", "gu"), I = (n, t = !0) => {
  const e = n.replace(_, (r) => `-${r.toLowerCase()}`);
  return t ? e : e.startsWith("-") ? e.slice(1) : e;
};
I.reverse = (n) => n.replace(f, (t) => t.slice(1).toUpperCase());
function g(n, t) {
  const e = Object.fromEntries(
    Object.entries(t ?? {}).map(([r, s]) => [
      `--${I(r)}`,
      s
    ])
  );
  return {
    ...n,
    ...e
  };
}
const p = "_grid_xdmtw_1", E = "_gridItem_xdmtw_42", w = "_header_xdmtw_51", S = "_imageSection_xdmtw_55", x = "_content_xdmtw_62", C = "_footer_xdmtw_69", h = "_landscape_xdmtw_87", i = {
  grid: p,
  gridItem: E,
  header: w,
  imageSection: S,
  content: x,
  footer: C,
  landscape: h
};
function o({
  children: n,
  className: t,
  style: e,
  forceLandscape: r,
  css: s,
  ...u
}, l) {
  return /* @__PURE__ */ c(
    "section",
    {
      ref: l,
      ...u,
      style: g(e, s),
      className: m(
        t,
        i.grid,
        r ? i.landscape : null
      ),
      children: n
    }
  );
}
o.GridItem = function({
  children: t,
  className: e,
  as: r = "article",
  ...s
}) {
  return /* @__PURE__ */ c(r, { ...s, className: m(e, i.gridItem), children: t });
};
function a({
  children: n,
  className: t,
  as: e = "section",
  ...r
}) {
  return /* @__PURE__ */ c(e, { ...r, className: t, children: n });
}
o.GridItemHeader = function({
  children: t,
  className: e,
  ...r
}) {
  return /* @__PURE__ */ c(
    a,
    {
      className: m(i.header, e),
      as: "header",
      ...r,
      children: t
    }
  );
};
o.GridItemImageSection = function({
  children: t,
  className: e,
  ...r
}) {
  return /* @__PURE__ */ c(
    a,
    {
      className: m(i.imageSection, e),
      as: "section",
      ...r,
      children: t
    }
  );
};
o.GridItemContent = function({
  children: t,
  className: e,
  ...r
}) {
  return /* @__PURE__ */ c(
    a,
    {
      className: m(i.content, e),
      as: "section",
      ...r,
      children: t
    }
  );
};
o.GridItemFooter = function({
  children: t,
  className: e,
  ...r
}) {
  return /* @__PURE__ */ c(
    a,
    {
      className: m(i.footer, e),
      as: "footer",
      ...r,
      children: t
    }
  );
};
const d = G(
  o
);
d.GridItem = o.GridItem;
d.GridItemHeader = o.GridItemHeader;
d.GridItemImageSection = o.GridItemImageSection;
d.GridItemContent = o.GridItemContent;
d.GridItemFooter = o.GridItemFooter;
export {
  d as default
};
//# sourceMappingURL=ProductGrid.js.map
